import React from "react";
import classNames from "classnames";
import { useTranslation } from 'react-i18next';

import SearchInput from "components/uiComponents/SearchInput";

const GlobalFilter = ({ table, className }) => {
  const { t } = useTranslation();
  
  const { globalFilter = "" } = table.getState();

  const handleChangeText = (e) => table.setGlobalFilter(e.target.value);
  const handleClear = () => table.setGlobalFilter("");

  return (
    <SearchInput
      size="md"
      type="text"
      name="sideSearch"
      placeholder={`${t('search')}...`}
      width={250}
      value={globalFilter}
      onChange={handleChangeText}
      onHideSearch={handleClear}
      className={classNames("find", className)}
      isVisible
    />
  );
};

export default GlobalFilter;
